import React from 'react'
import T from 'prop-types'
import { Stack, Typography } from '@mui/material'
import { format, parse } from 'date-fns'
import itLocale from 'date-fns/locale/it'
import { useTranslation } from 'react-i18next'

export default function CarDetailsItemMaintenance({
  title,
  odometer,
  summary,
  icon,
  titleContainerProps,
  titleProps,
  odometerProps,
  summaryProps,
  iconProps,
  formatItems = true,
  ...others
}) {
  const { t } = useTranslation()

  const numberFormatter = new Intl.NumberFormat('it-IT')

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      {...others}
      sx={{ py: 1, ...others?.sx }}
    >
      <Stack sx={{ flex: 1 }}>
        {(title || icon) && (
          <Stack direction="row" alignItems="center" {...titleContainerProps}>
            {icon && (
              <icon.type
                fontSize="small"
                {...iconProps}
                sx={{ mr: 1, ...iconProps?.sx }}
              />
            )}
            {title && (
              <Typography
                component="span"
                variant="body2"
                color="textPrimary"
                {...titleProps}
              >
                <span>
                  {formatItems
                    ? format(
                        new Date(parse(title, 'yyyy-MM-dd', new Date())),
                        t('common.date.formatDMY'),
                        {
                          locale: itLocale,
                        }
                      )
                    : title}
                </span>
              </Typography>
            )}
          </Stack>
        )}
      </Stack>
      <Stack sx={{ flex: 0.5, px: 2 }}>
        <Typography variant="body2" color="textPrimary" {...odometerProps}>
          {formatItems
            ? odometer && numberFormatter.format(odometer)
            : odometer}
        </Typography>
      </Stack>
      <Stack sx={{ flex: 1.55, textAlign: 'justify', px: 2 }}>
        <Typography variant="body2" color="textPrimary" {...summaryProps}>
          {summary}
        </Typography>
      </Stack>
    </Stack>
  )
}

CarDetailsItemMaintenance.propTypes = {
  title: T.string,
  odometer: T.string,
  summary: T.string,
  icon: T.object,
  others: T.object,
  titleContainerProps: T.object,
  titleProps: T.object,
  odometerProps: T.object,
  summaryProps: T.object,
  iconProps: T.object,
}
